import { GlobalSearchCategory, chipOptions } from "@ubif/types";
import { SearchCustomersResponse, hasEnoughSearchCriteria } from "@ubif/util-store";

import { shouldSkipCustomerJobSearch } from "./customerSearchJobQueries";

/**
 * Whether quick-search should skip workorder / arrival / salesorder fetches.
 * Typed claims/workorders require enough characters; scanned salesId still bypasses the length gate.
 */
export const shouldSkipWorkorderSearch = (
  searchCategory: GlobalSearchCategory,
  debouncedSearchCriteria: string | undefined,
  salesId: string | undefined,
  searchedCustomersData?: SearchCustomersResponse
): boolean => {
  if (
    searchCategory === chipOptions.workorders.searchCategory ||
    searchCategory === chipOptions.claims.searchCategory
  ) {
    return !hasEnoughSearchCriteria(searchCategory, debouncedSearchCriteria) && !salesId;
  }

  return shouldSkipCustomerJobSearch(searchCategory, chipOptions.customers.searchCategory, searchedCustomersData);
};
